import Box from "@mui/material/Box";

import {
  borderOverlaySx,
  BORDER_OVERLAY_WIDTH
} from "~/features/andon/andon.styles";
import {
  AndonCellBorder,
  DEFAULT_CELL_BORDER_COLOR
} from "~/features/andon/andon.types";
import { calculateAndonGridCellKey } from "~/features/andon/andon.utils";

type BorderOverlayProps = {
  columns: number;
  rows: number;
  rowPitch: number;
  cellBorders: AndonCellBorder[];
};

export default function BorderOverlay({
  columns,
  rows,
  rowPitch,
  cellBorders
}: BorderOverlayProps) {
  if (!cellBorders?.length) return null;

  const borderByKey = new Map(
    cellBorders.map((cellBorder) => [
      calculateAndonGridCellKey(cellBorder),
      cellBorder
    ])
  );
  const rowTemplate =
    rowPitch > 0 ? `repeat(${rows}, ${rowPitch}px)` : `repeat(${rows}, 1fr)`;

  return (
    <Box aria-hidden sx={borderOverlaySx(columns, rowTemplate)}>
      {Array.from({ length: rows }).flatMap((_, y) =>
        Array.from({ length: columns }).map((__, x) => {
          const cellKey = calculateAndonGridCellKey({ x, y });
          const border = borderByKey.get(cellKey);
          const sides = border?.sides;
          const line = `${BORDER_OVERLAY_WIDTH}px solid ${
            border?.color || DEFAULT_CELL_BORDER_COLOR
          }`;
          return (
            <div
              key={cellKey}
              className="andon-border-cell"
              style={{
                boxSizing: "border-box",
                borderTop: sides?.includes("top") ? line : undefined,
                borderRight: sides?.includes("right") ? line : undefined,
                borderBottom: sides?.includes("bottom") ? line : undefined,
                borderLeft: sides?.includes("left") ? line : undefined
              }}
            />
          );
        })
      )}
    </Box>
  );
}
